export default __webpack_public_path__ + "static/media/sort-up-solid.3432ded9.svg";